const INITIAL_STATE = {
    authUser: null,
  };
  
  const applySetAuthUser = (state, action) =>{
  return ({
    ...state,
    authUser: action.payload
  });}
  
  function sessionReducer(state = INITIAL_STATE, action) {
    switch(action.type) {
      case 'AUTH_USER_SET' : {
        return applySetAuthUser(state, action);
      }
      default : return state;
    }
  }
  
  export default sessionReducer;


// WEBPACK FOOTER //
// ./src/reducers/session.js